import { LogOut } from 'lucide-react';
import type { PaigeWorkbenchPerson } from '../paige/paige.global';

/** Who the workspace menu is for: Paige's bridge names them; the desktop, with no bridge, has nobody to name. */
export function workbenchPerson(): PaigeWorkbenchPerson | undefined {
  if (typeof window === 'undefined') return undefined;
  return window.paigeWorkbench?.person;
}

/**
 * The first section of the workspace menu inside Paige: the person's name with their company as a
 * caption, then Sign out (IMPLEMENTATION.md sell-ready sprint 2, row 25). Nothing else of the
 * account lives here; companies, settings and two-step sign-in are the dashboard's.
 */
export function WorkbenchPersonSection({
  person,
  onChoose,
}: {
  person: PaigeWorkbenchPerson;
  /** Closes the menu, then runs the entry. */
  onChoose: (action: () => void) => void;
}) {
  return (
    <>
      <div role="separator" />
      <div className="workbench-menu-person">
        <strong>{person.name}</strong>
        <span>{person.company}</span>
      </div>
      <button
        type="button"
        role="menuitem"
        tabIndex={-1}
        aria-label={`Sign out ${person.name}`}
        onClick={() => onChoose(person.signOut)}
      >
        <LogOut size={22} />
        <span>Sign out</span>
      </button>
    </>
  );
}
